"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateRecipientEmail = exports.validateDeliveryTime = exports.validateDeliveryDetailsForm = exports.validateDeliveryDate = exports.validateConfirmRecipientEmail = exports.isDateInFuture = void 0;
var _store = _interopRequireDefault(require("../../../redux/store"));
var _deliveryDetailsSlice = require("../../../redux/deliveryDetailsSlice");
var _validators = require("../../../util/validators");
const validateRecipientEmail = value => {
  const error = (0, _validators.validateEmailField)(value);
  const translationKey = !value ? 'recipientForm.error.missing-value' : 'recipientForm.error.bad-email-format';
  _store.default.dispatch((0, _deliveryDetailsSlice.setFieldError)({
    name: 'recipientEmail',
    error,
    translationKey: error ? translationKey : ''
  }));
  return !error;
};
exports.validateRecipientEmail = validateRecipientEmail;
const isDateInPast = date => {
  if (!date) return false;
  const now = new Date();
  return date < now;
};
const isDateInFuture = date => {
  if (!date) return false;
  const now = new Date();
  return date.setHours(0, 0, 0, 0) > now.setHours(0, 0, 0, 0);
};
exports.isDateInFuture = isDateInFuture;
const validateDeliveryDate = (value, deliveryTime) => {
  const deliveryDate = new Date("".concat(value, "T").concat(deliveryTime));
  let error = '';
  if (!value) {
    error = 'Missing delivery date';
  }
  if (isDateInPast(deliveryDate)) {
    error = 'Invalid delivery date';
  }
  _store.default.dispatch((0, _deliveryDetailsSlice.setFieldError)({
    name: 'deliveryDate',
    error,
    translationKey: !value ? 'recipientForm.error.delivery-date' : ''
  }));
  return !error;
};
exports.validateDeliveryDate = validateDeliveryDate;
const validateDeliveryTime = (value, deliveryDate) => {
  let error = '';
  if (!value) {
    error = 'Missing delivery time';
  }
  _store.default.dispatch((0, _deliveryDetailsSlice.setFieldError)({
    name: 'deliveryTime',
    error,
    translationKey: !value ? 'recipientForm.error.delivery-time' : ''
  }));
  if (deliveryDate) {
    const date = new Date("".concat(deliveryDate, "T").concat(value));
    if (isDateInPast(date)) {
      error = 'Invalid delivery date';
    }
    _store.default.dispatch((0, _deliveryDetailsSlice.setFieldError)({
      name: 'deliveryDate',
      error,
      translationKey: !value ? 'recipientForm.error.delivery-date' : ''
    }));
  }
  return !error;
};
exports.validateDeliveryTime = validateDeliveryTime;
const validateConfirmRecipientEmail = value => {
  if ((0, _validators.validateEmailField)(value)) {
    _store.default.dispatch((0, _deliveryDetailsSlice.setFieldError)({
      name: 'confirmRecipientEmail',
      error: (0, _validators.validateEmailField)(value),
      translationKey: !value ? 'recipientForm.error.missing-value' : 'recipientForm.error.bad-email-format'
    }));
    return false;
  }
  const {
    deliveryDetails: {
      recipientEmail,
      confirmRecipientEmail
    }
  } = _store.default.getState();
  const doEmailsMatch = recipientEmail.value === confirmRecipientEmail.value;
  _store.default.dispatch((0, _deliveryDetailsSlice.setFieldError)({
    name: 'confirmRecipientEmail',
    error: doEmailsMatch ? '' : 'Email address doesn’t match',
    translationKey: doEmailsMatch ? '' : 'recipientForm.error.confirm-recipient-email.doesnt-match'
  }));
  return doEmailsMatch;
};
exports.validateConfirmRecipientEmail = validateConfirmRecipientEmail;
const validateDeliveryDetailsForm = () => {
  const {
    deliveryDetails: {
      recipientEmail,
      confirmRecipientEmail,
      deliveryDate,
      deliveryTime
    }
  } = _store.default.getState();
  const isRecipientEmailValid = validateRecipientEmail(recipientEmail.value);
  const isConfirmRecipientEmailValid = validateConfirmRecipientEmail(confirmRecipientEmail.value);
  const isDeliveryDateValid = validateDeliveryDate(deliveryDate.value, deliveryTime.value);
  const areDeliveryDetailsValid = isRecipientEmailValid && isConfirmRecipientEmailValid && isDeliveryDateValid;
  return areDeliveryDetailsValid;
};
exports.validateDeliveryDetailsForm = validateDeliveryDetailsForm;